import { Card, Box, Typography, Divider, Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PeopleIcon from '@mui/icons-material/People';
import ApartmentIcon from '@mui/icons-material/Apartment';

const BigMetric = ({ label, value, icon }) => (
    <Box
        sx={{
            flex: 1,
            height: 150,
            backgroundColor: '#f5f6f8',
            borderRadius: 0,
            m: 0.5,
            py: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        {icon && (
            <Box mb={0.5} color="primary.main">
                {icon}
            </Box>
        )}

        <Typography
            variant="caption"
            color="text.secondary"
            sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}
        >
            {label}
        </Typography>

        <Typography variant="h3" fontWeight={800} color="primary" lineHeight={1.1}>
            {value.toLocaleString()}
        </Typography>
    </Box>
);

const SmallMetric = ({ label, value }) => (
    <Box textAlign="center">
        <Typography variant="h3" fontWeight={700} color="primary">
            {value.toLocaleString()}
        </Typography>
        <Typography variant="caption" color="text.secondary">
            {label}
        </Typography>
    </Box>
);

const PlatformSummaryCard = ({ stats }) => {
    const { t } = useTranslation();

    return (
        <Card
            sx={{
                height: '100%',
                p: 3,
                borderRadius: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}
        >
            {/* Header */}
            <Typography variant="h3" fontWeight={700} color="primary" gutterBottom mb={1}>
                {t('management.platformOverview')}
            </Typography>

            {/* Big KPIs */}
            <Box display="flex" justifyContent="space-between">
                <BigMetric
                    label={t('management.totalClinics')}
                    value={stats.clinics}
                    icon={<ApartmentIcon fontSize="large" />}
                />
                <BigMetric
                    label={t('management.totalPatients')}
                    value={stats.patients}
                    icon={<PeopleIcon fontSize="large" />}
                />
            </Box>

            {/* Secondary KPIs */}
            <Grid container spacing={2} mt={2}>
                <Grid size={4}>
                    <SmallMetric label={t('management.doctors')} value={stats.doctors} />
                </Grid>
                <Grid size={4}>
                    <SmallMetric label={t('management.groups')} value={stats.groups} />
                </Grid>
                <Grid size={4}>
                    <SmallMetric
                        label={t('management.activePlans')}
                        value={stats.activeTrainingPlans}
                    />
                </Grid>
                <Grid size={4}>
                    <SmallMetric
                        label={t('management.exercises')}
                        value={stats.exercisesCompleted}
                    />
                </Grid>
                <Grid size={4}>
                    <SmallMetric
                        label={t('management.alerts')}
                        value={stats.alertsDetected}
                    />
                </Grid>
                <Grid size={4}>
                    <SmallMetric
                        label={t('management.questionnaires')}
                        value={stats.questionnairesAnswered}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default PlatformSummaryCard;
